import { Outlet } from 'react-router-dom';

const Assets = () => {
  return (
    <div className="flex h-full overflow-hidden bg-neutral-50">
      <div className="flex w-full flex-col">
        <Outlet />
      </div>
    </div>
  );
};

export default Assets;
